module.exports = __webpack_public_path__ + "6faedb3c1a8d015b49bebbc95c6d93e5.png";


//////////////////
// WEBPACK FOOTER
// ./images/pics2/9.png
// module id = 307
// module chunks = 0